import React,{useState,useEffect,useContext} from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { ToastContainer, toast } from "react-toastify";
import { ManagerAuthContext } from "../context/AuthManager";
import Modal from "react-bootstrap/Modal";
import moment from "jalali-moment";

export const AdminConsultant = () => {
  const { currentUserRF } = useContext(ManagerAuthContext);


//date: moment(new Date(), "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD"),
const [date,setDate] = useState(moment(new Date(), "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD"));
const today = moment(new Date(), "YYYY-MM-DD").locale("fa").format("YYYY-MM-DD");

const [userList, setUserList] = useState([]);

useEffect(() => {
const getAllProductsRT = async () => {
    const res = await fetch(
    `https://clinic.salamatpayanew.ir/Register/filterDateTwo/${currentUserRF.nezam}&${today}`
    );
    setUserList(await res.json());
};
  getAllProductsRT();
}, [userList]);

const handelBack = async(id) =>{
  await axios.put(`https://clinic.salamatpayanew.ir/admin/updateStat/${id}`,{
    stat:'2',
    sts: 'پایان یافته'
  })
}

const [showb, setShowb] = useState(false);
const handleCloseb = () => setShowb(false);
const handleShowb = () => setShowb(true);


const [showbX, setShowbX] = useState(false);
const handleClosebX = () => setShowbX(false);
const handleShowbX = () => setShowbX(true);


const [serviceList, setServiceList] = useState([]);

useEffect(() => {
const getAllProductsRT = async () => {
    const res = await fetch(
    `https://clinic.salamatpayanew.ir/admin/ListServices/${currentUserRF.nezam}`
    );
    setServiceList(await res.json());
};
  getAllProductsRT();
}, [userList]);


const [names,setnames] = useState('')
const [melis,setMelis] = useState('')

const showServices = (id,name,meli) =>{
  setnames(name);
  setMelis(meli);
  setSum('')
  setArtists([])
  handleShowb(true)
  
}
const showServicest = (id,name,meli) =>{
  setnames(name);
  setMelis(meli);
  
}
const getData = (e,nameServ,price) => {
  artists.push({nameserv:nameServ,price:price,name:names,meli:melis,nezam:currentUserRF.nezam,date:today})
  e.currentTarget.disabled = true;
 }
 
const HandelClearList = () =>{
   setArtists([])
   handleCloseb(true)
}
var temp = 0;
const [sum, setSum] = useState(0)

const handelRow = async() => {
  {artists.map((values) => {
    temp = temp + values.price * 1
  })}

  setSum(temp)

await axios.post('https://clinic.salamatpayanew.ir/admin/registerServicesPrice', artists).then(() =>{
    toast.success("ثبت سرویس انجام شد")
  }).catch(() =>{
    toast.error("خطا در ثبت سرویس")
  })
  handleCloseb(true)
}

const [artists, setArtists] = useState([]);
const[servfinde,setServFinde] = useState('')

const [restA,setAlldataget] = useState([]);

/* const getAllTree = async () =>{
  const res = await api.get(
     `/Represent/getAllList/${currentUser.nezam}`
   );
  setResp(await res.data);
  } */

const updateserviceT = async(meliX,dateX) => {

  const res = await fetch(
    `https://clinic.salamatpayanew.ir/Register/listUPdateallDataTEST/${meliX}&${dateX.replace("/","-").replace("/","-")}&${currentUserRF.nezam}`);

    setAlldataget(await res.json());
    handleShowbX(true);  
   
}

const hadelDeleteServicer = async(id) => {
  try{
     axios
    .delete(`https://clinic.salamatpayanew.ir/Register/deleteDateServiceS/${id}`)
    .then((response) => {
      setAlldataget((values) => {
        return values.filter((item) => item.id !== id);
      });
      toast.success("حذف  با موفقیت انجام شد");
    });
  }catch(err){
      toast.error("عملیات حذف غیر فعال میباشد")
  }
}

// 

if (currentUserRF.meli === null) {
     } else {
  return (
   <>
        <section class="m-0 content" dir='rtl'>
            <h5>بیماران ارجاع داده شده به پزشک</h5>
            <div class="row">
                <div class="table-responsive">
                    <table class="table bg-white custom-rounded t-24 table-responsive">
                        <thead>
                            <tr class="text-center">
                                <th><span>نام بیمار</span></th>
                                <th><span>کد ملی</span></th>
                                <th><span>تاریخ تولد</span></th>
                                <th><span>وضعیت</span></th>
                                <th><span>پرونده بیمار</span></th>
                                <th><span>سرویس</span></th>
                                <th><span>فرم بارداری</span></th>
                                <th><span>س-ق</span></th>
                                <th><span>تایید نهایی</span></th>
                            </tr>
                        </thead>
                    {userList
                      .map((item, index) => {
                    const { id, name,meli,nezam,year,insu } = item;
                  return (
                    <tbody
                      class="table-group-divider table-divider-color"
                      key={item.id}
                    >
                            <tr>
                                <td>{item.name}</td>
                                <td>{item.meli}</td>
                                <td>{item.insu}</td>
                                <td>{item.type}</td>
                                <td>
                               <Link
                                  to="/AdminPanel/folderCardex"
                                  state={{
                                    id,
                                    name,
                                    meli,
                                    nezam,
                                    insu}}>
                                  <img src='/img/par.png' height={"25px"} width={"25px"}  style={{cursor:'pointer'}} title='پرونده بیمار' /></Link>
                                    </td>
                                <td><img src='/img/ser.png' height={"25px"} width={"25px"}  style={{cursor:'pointer'}} title='ایجاد سرویس' onClick={() =>showServices(id,name,meli)} /></td>
                                <td>
                                <Link
                                  to="/AdminPanel/PregnancyForm"
                                  state={{
                                    id,
                                    name,
                                    meli,
                                    nezam,
                                    insu}}><img src='/img/bar.png' height={"25px"} width={"25px"}  style={{cursor:'pointer'}} title='فرم بارداری'  /></Link>
                                  </td>
                                  <td><img src='/img/Aedit.png' height={"25px"} width={"25px"}  style={{cursor:'pointer'}} title='سرویس های گذشته' onClick={() =>updateserviceT(meli,date)}/></td>
                                  <td><img src='/img/act.png' height={"25px"} width={"25px"}  style={{cursor:'pointer'}} title='بازگشت به منشی' onClick={() =>handelBack(id)} /></td>
                            </tr>
                        </tbody>
                    );
                })}
                    </table>

                </div>
            </div>
        </section>

<Modal show={showb} onHide={handleCloseb}>
       <Modal.Body>
        <div class="table-responsive" dir='rtl'>
        <input type='text' className='form-control' placeholder='جستجو سرویس' onChange={(e) =>setServFinde(e.target.value)}/>
             <table class="table bg-white custom-rounded t-24 table-responsive">
                        <thead>
                            <tr class="text-center">
                              <th>کد</th>
                                <th>سرویس</th>
                                <th>مبلغ</th>
                            </tr>
                        </thead>
                        
          
              {serviceList.filter
                ((val) => {
                if (servfinde === "") {
                        return val;
                      } else if (
                        val.name
                          .toLowerCase()
                          .includes(servfinde.toLowerCase())
                      )
                      return val;
                })
                .map((item, index) => {
                    const { id,name,price} = item;
                  return (
                    <tbody
                      class="table-group-divider table-divider-color"
                      key={item.id}>
                            <tr>
                                <td>{item.id}</td>
                                <td>{item.name}</td>
                                <td>{item.price}</td>
                                <td>
                                <button className='btn btn-info' onClick={() => {
                                    setArtists([
                                      ...artists,
                                      { id: id, name: name,price:price,meli:melis,nezam:currentUserRF.nezam,date:today,nameserv:names}
                                      // nameserv:nameServ,price:price,name:names,meli:melis,nezam:currentUserRF.nezam,date:today                                      
                                    ]);
                                  }}>+</button>
                                </td>
                            </tr>
                    </tbody>
              );
          })}
</table>
   <table class="table bg-white custom-rounded t-24 table-responsive">
                        <thead>
                     <tr class="text-center">
                      <div style={{textAlign:'center'}}>لیست خدمات دریافتی بیمار</div>
                     </tr>
                 </thead>
     {artists.map(artist => (
             <tbody
               class="table-group-divider table-divider-color">
                     <tr>
                     <td hidden>{artist.id}</td>
                             <td>{artist.name}</td> 
                             <td>{artist.price}</td>
                             <td><button className='btn btn-danger' onClick={() => {
                               setArtists(
                                 artists.filter(a =>
                                   a.id !== artist.id
                                 )
                               );
                             }}>
                               -
                             </button>
                             </td>
                     </tr>
             </tbody>
             
          ))}
       </table>
      <hr />
           {
              artists.map((values) => {
                temp = temp + values.price * 1
               })  
            }
           <span style={{color:'green'}}>جمع کل خدمات  :  {temp}</span>
           <hr />
        <div style={{textAlign:'center'}}>
       <button className='btn btn-success' onClick={handelRow}>تایید لیست خدمات</button>
       </div>
  </div>
  </Modal.Body>
</Modal>

<Modal show={showbX} onHide={handleClosebX}>
       <Modal.Body>
      <table class="table bg-white custom-rounded t-24 table-responsive">
                        <thead>
                     <tr class="text-center">
                      <div style={{textAlign:'center'}}>لیست خدمات دریافتی بیمار</div>
                     </tr>
                 </thead>
     {restA.map(item => (
      
             <tbody class="table-group-divider table-divider-color">
                     <tr>
                             <td hidden>{item.id}</td>
                             <td>{item.name}</td> 
                             <td>{item.price}</td>
                             <td><img src='/img/del.png' height={"25px"} width={"25px"}  style={{cursor:'pointer'}} title='حذف' onClick={() =>hadelDeleteServicer(item.id)} /></td>
                     </tr>
             </tbody>
             
          ))}
       </table>
      <hr />
        <div style={{textAlign:'center'}}>
       </div>
  
  </Modal.Body>
</Modal>

       <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

   </>
  )
}

}